module.exports = __webpack_public_path__ + "images/structure_fig1_93f1b78.jpg";